import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { List, ListItem, Link } from '@material-ui/core';
import { appRoutes } from 'routes';

import useStyles from './useStyles';

const NAVIGATION_ITEMS = [
  {
    id: 0,
    label: 'components.Footer.navLinks.aboutUs',
    to: appRoutes.aboutUsPath(),
    MuiComponent: Link,
    targetComponent: RouterLink,
  },
  {
    id: 1,
    label: 'components.Footer.navLinks.blog',
    href: 'https://bundleloan.com/blog',
    target: '_blank',
    MuiComponent: Link,
  },
  {
    id: 5,
    label: 'components.Footer.navLinks.privacy',
    to: appRoutes.privacyPath(),
    MuiComponent: Link,
    targetComponent: RouterLink,
  },
  {
    id: 6,
    label: 'components.Footer.navLinks.terms',
    to: appRoutes.termsPath(),
    MuiComponent: Link,
    targetComponent: RouterLink,
  },
];

const SecondaryNav = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { onClose } = props;
  return (
    <List className={classes.navList}>
      {NAVIGATION_ITEMS.map(({ label, to, href, target, id, MuiComponent, targetComponent }) => (
        <ListItem className={classes.navItem} key={id} onClick={onClose}>
          <MuiComponent className={classes.navLink} component={targetComponent} target={target} to={to} href={href}>
            {t(label)}
          </MuiComponent>
        </ListItem>
      ))}
    </List>
  );
};

export default SecondaryNav;



// WEBPACK FOOTER //
// ./src/sharedComponents/SecondaryNav/SecondaryNav.js